export enum PaymentType {
  Credit = 'credit',
  Debit = 'debit',
}
